import React from 'react';
import { ZapIcon, TrendingUpIcon, ShieldCheckIcon } from 'lucide-react';
const ImpactMetrics = () => {
  const metrics = [{
    icon: <ZapIcon size={28} className="text-orange-500" data-id="element-211" />,
    percentage: '95%',
    suffix: 'faster',
    description: "form completion by letting users respond the way that's easiest — not forcing rigid inputs."
  }, {
    icon: <TrendingUpIcon size={28} className="text-orange-500" data-id="element-212" />,
    percentage: '30%',
    suffix: 'higher',
    description: 'completion rates with conversational, multi-modal form experiences.'
  }, {
    icon: <ShieldCheckIcon size={28} className="text-orange-500" data-id="element-213" />,
    percentage: '96%',
    suffix: 'higher',
    description: 'data accuracy with AI-powered validation of both form data and uploaded documents.'
  }];
  return <section className="w-full bg-gray-50 border-t border-gray-200 py-[3.8rem]" data-id="element-214">
      <div className="container mx-auto px-4" data-id="element-215">
        <div className="text-center mb-16" data-id="element-216">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-217">
            The FluidForm Difference
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-218">
          {metrics.map((metric, index) => <div key={index} className="flex flex-col items-center text-center p-6" data-id="element-219">
              <div className="bg-orange-50 w-16 h-16 rounded-2xl flex items-center justify-center mb-6" data-id="element-220">
                {metric.icon}
              </div>
              <div className="flex items-baseline gap-2 mb-3" data-id="element-221">
                <span className="text-5xl font-bold text-gray-900" data-id="element-222">
                  {metric.percentage}
                </span>
                <span className="text-xl font-semibold text-orange-500" data-id="element-223">
                  {metric.suffix}
                </span>
              </div>
              <p className="text-gray-600 leading-relaxed max-w-xs" data-id="element-224">
                {metric.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default ImpactMetrics;